import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

export const NotFound = ({ message = "Property Not Found", redirectPath = "/rent/all", autoRedirect = true, redirectDelay = 3000 }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (autoRedirect) {
      const timer = setTimeout(() => {
        navigate(redirectPath, { replace: true });
      }, redirectDelay);

      return () => clearTimeout(timer);
    }
  }, [navigate, redirectPath, autoRedirect, redirectDelay]);

  return (
    <div className="w-full h-screen flex items-center justify-center bg-[#fafafa]">
      <div className="text-center max-w-md mx-auto px-4">
        <div className="text-6xl sm:text-8xl font-bold text-[#5b1dee] mb-4">404</div>
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2">{message}</h2>
        <p className="text-gray-600 mb-6 text-sm sm:text-base">
          The property you're looking for doesn't exist or has been removed.
        </p>
        <button
          onClick={() => navigate(redirectPath, { replace: true })}
          className="bg-[#5b1dee] text-white px-6 py-3 rounded-lg font-medium hover:bg-[#4a1ac7] transition-colors shadow-[2px_2px_6px_0px_rgba(91,29,238,0.4)]"
        >
          Go to Properties
        </button>
        {autoRedirect && (
          <p className="text-gray-400 text-xs sm:text-sm mt-4">
            Redirecting automatically in {redirectDelay / 1000} seconds...
          </p>
        )}
      </div>
    </div>
  );
};









